import { useQuery } from '@tanstack/react-query';

import getCurrencyConversionApi from '@/apis/get-currency-conversion.api';
import QUERY_KEYS from '@/constants/query-keys';

export default function useGetCurrencyConversion(
  from: string | undefined,
  to: string | undefined,
  amount?: number | undefined
) {
  const { data, isPending: isPendingConversion } = useQuery({
    queryKey: QUERY_KEYS.CURRENCY_CONVERSION(from!, to!, amount),
    queryFn: () => getCurrencyConversionApi(from!, to!, 1),
    staleTime: 1000 * 60 * 60 * 2, // 2 hours
    enabled: !!from && !!to && !!amount,
  });

  return {
    rate: {
      from,
      to,
      amount: data?.amount || 0,
    },
    converted: {
      from,
      to,
      amount: (amount || 1) * (data?.amount || 0),
    },
    isPendingConversion,
  };
}
